export const normalizeCountryOptions = (countries = []) => {
  const sorted = [...(countries || [])].filter(Boolean).sort((a, b) => {
    const firstName = a?.countryName || a?.name || "";
    const secondName = b?.countryName || b?.name || "";
    return firstName.localeCompare(secondName);
  });

  return sorted
    .map((item) => ({
      label: item?.countryName || item?.name || "",
      value: item?.countryName || item?.name || "",
      countryId:
        item?.countryId || item?.id || item?.country_id || item?.countryID,
    }))
    .filter((item) => item.label);
};

export const sortedCountries = (countries) => {
  const seen = new Set();
  return [...(countries || [])]
    .filter(Boolean)
    .filter((item) => {
      const key = item?.value || "";
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => {
      const firstName = a?.value || "";
      const secondName = b?.value || "";
      return firstName.localeCompare(secondName);
    });
};
